import { combineReducers } from 'redux'
import { settings } from '../settings/store'
import { bgLimits } from '../limitRequests/store'
import { requests } from '../requests/store'
import { email } from '../common/store'

export const iBro = combineReducers({
	requests,
	bgLimits,
	settings,
	email,
})
